import React, { useState, useContext, useEffect, useRef } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { Formik } from "formik";
import { ToastContext } from "../../context/toastProvider";
import StoreService from "../../api/services/storeService";
import Loader from "../loader/loader";
import campaignService from "../../api/services/campaignService";
import Dropzone from "react-dropzone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import InfoIcon from "../icons/InfoIcon";
import "./Campaign.css";
import DownloadIcon from "../icons/DownloadIcon";
import CampaignPDF from "../../assets/Create_Campaign.pdf";
import CampaignPdfThumbnail from "../../assets/images/campaignPdfThumbnail.png";
import SendIcon from "../../assets/images/send.png";
import RefreshIcon from "../../assets/images/refresh.png";
import SearchIcon from "../icons/searchIcon";
import { Fancybox } from "@fancyapps/ui";
import aiService from "../../api/services/aiService";
import CreateThumbnail from "../../assets/images/createThumbnail.png";

function AddCampaign() {
  const [isInitialPopup, setShowInitialPopup] = useState(false);
  const [isInitialPopup2, setShowInitialPopup2] = useState(false);
  const [isLoading, setIsLoading] = useState();
  const { initToast } = useContext(ToastContext);
  const [stores, setStores] = useState();
  const [banner, setBanner] = useState();
  const [fileBanner, setFileBanner] = useState();
  const history = useHistory();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [b64, setB64] = useState();

  const getStores = async () => {
    try {
      const resp = await StoreService.getStores();
      if (resp.code === 0) {
        let temp = [];
        resp.storeList.forEach((item, key) => {
          temp.push({
            name: item.STORENAME,
            id: item.STOREID,
          });
        });
        setStores(temp);
      }
    } catch (error) {}
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleFileReadBanner = async (event) => {
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    setB64(base64.replace(/^data:image\/[a-z]+;base64,/, ""));
  };

  const handleOnClick = () => {
    setShowInitialPopup(false);
    document.body.removeEventListener("click", () => {});
  };
  useEffect(() => {
    const item = localStorage.getItem("initialPopupCampaionManage");
    if (item && item === "1") {
      setShowInitialPopup(true);
      localStorage.setItem("initialPopupCampaionManage", "");
      document.body.addEventListener("click", handleOnClick);
    }

    Fancybox.bind('[data-fancybox="gallery"]', {
      // Настройки Fancybox
    });

    getStores();
    return () => {
      Fancybox.destroy();
    };
  }, []);
  const [editImage, setEditImage] = useState(false);
  const cropperRef = useRef(null);
  const onSaveCrop = async (e) => {
    e.preventDefault();
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    setBanner({
      ...banner,
      campaignBanner: cropper.getCroppedCanvas().toDataURL(),
    });
    const base64 = cropper.getCroppedCanvas().toDataURL();
    setB64(base64.replace(/^data:image\/[a-z]+;base64,/, ""));
    setFileBanner(cropper.getCroppedCanvas().toDataURL());

    setEditImage(false);
  };

  const onClearCrop = (e) => {
    e.preventDefault();
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    if (cropper) {
      cropper.clear();
    }
    setFileBanner(null);
    setBanner({
      ...banner,
      campaignBanner: null,
    });
    setEditImage(false);
  };

  const generateAICampainDesc = async (prompt, setFieldValue) => {
    try {
      const resp = await aiService.getAiCampaignDescription({
        prompt,
        maxLength: 250,
      });
      if (resp?.SUCCESS) {
        setFieldValue("campaignDescription", resp?.MESSAGE);
      }
    } catch (error) {}
  };

  const generateAICampainSMSDesc = async (prompt, setFieldValue) => {
    try {
      const resp = await aiService.getAiCampaignDescription({
        prompt,
        maxLength: 120,
      });
      if (resp?.SUCCESS) {
        setFieldValue("campaignSMSText", resp?.MESSAGE);
      }
    } catch (error) {}
  };

  return (
    <Card>
      <CardTitle className="border-bottom p-3 mb-0 font-weight-bold text-uppercase">
        Create Campaign
      </CardTitle>
      <CardBody>
        <p className="text-secondary">
          Set up your campaign by completing all of the fields provided, as
          instructed. Then click on CREATE CAMPAIGN to save your campaign for
          sending to your database.
        </p>
        <Loader isLoading={isLoading} />
        <Formik
          initialValues={{
            campaignName: "",
            give_back_campaign: "",
            campaignDescription: "",
            minimumValue: "",
            startDate: "",
            endDate: "",
            campaignIntro: " ",
            dashboardMemo: "-",
            campaignSMSText: "",
          }}
          enableReinitialize
          onSubmit={async (values) => {
            if (values.give_back_campaign < 15) {
              initToast(
                "error",
                "To build loyalty the minimum Give-back Percentage should be 15% or higher"
              );
            } else {
              setIsLoading(true);
              try {
                const resp = await campaignService.createCampaign({
                  ...values,
                  campaignBanner: b64,
                  startDate: startDate,
                  endDate: endDate,
                  active: "1",
                });
                if (resp && resp.success) {
                  setIsLoading(false);
                  history.goBack();
                  initToast("success", resp.message);
                } else {
                  setIsLoading(false);
                  initToast("error", resp.message);
                }
              } catch (error) {
                setIsLoading(false);
              }
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <form className="row g-2" onSubmit={handleSubmit}>
              <div className="col-6">
                <div className={"info-input"}>
                  <input
                    type="text"
                    className="form-controls-light"
                    placeholder="Title of offer for listing card"
                    id="campaignName"
                    value={values.campaignName}
                    onChange={handleChange}
                    name="campaignName"
                  />
                  <div className="info-input__icon">
                    <InfoIcon />
                  </div>
                  <div className="info-input__img">
                    <img src="/images/infoCampaign/1.jpg" alt="" />
                  </div>
                </div>
              </div>
              <div className="col-3">
                <DatePicker
                  onChange={(date) => setStartDate(date)}
                  dateFormat="MM/dd/yyyy"
                  placeholderText="Start Date"
                  selected={startDate}
                  className="form-controls-light"
                />
              </div>
              <div className="col-3 ">
                <DatePicker
                  onChange={(date) => setEndDate(date)}
                  dateFormat="MM/dd/yyyy"
                  placeholderText="End Date"
                  selected={endDate}
                  className="form-controls-light"
                />
              </div>
              <div className="col-6 mt-3">
                <div className="row">
                  <div
                    className="col-3"
                    style={{
                      paddingRight: 0,
                      flex: "0 0 26%",
                      maxWidth: "0 0 26%",
                    }}
                  >
                    <div className={"info-input"}>
                      <input
                        className="form-controls-light mt-3"
                        placeholder="Purchase amount"
                        id="minimumValue"
                        type="number"
                        value={values.minimumValue}
                        onChange={handleChange}
                        name="minimumValue"
                      />
                      <div className="info-input__icon">$</div>
                    </div>
                  </div>
                  <div
                    className="col-3"
                    style={{
                      paddingRight: 0,
                      flex: "0 0 26%",
                      maxWidth: "0 0 26%",
                    }}
                  >
                    <div className={"info-input"}>
                      <input
                        className="form-controls-light mt-3"
                        placeholder="Give-Back (15%+)"
                        id="give_back_campaign"
                        type="number"
                        value={values.give_back_campaign}
                        onChange={handleChange}
                        name="give_back_campaign"
                      />
                      <div className="info-input__icon">%</div>
                    </div>
                  </div>
                  <div
                    className="col-1"
                    style={{ paddingRight: 0, paddingLeft: 0, flex: "0 0 6%" }}
                  >
                    <div
                      className="info-input__icon"
                      style={{
                        right: 0,
                        left: 8,
                        top: 21,
                      }}
                      onMouseOver={() => setShowInitialPopup(true)}
                      onMouseOut={() => setShowInitialPopup(false)}
                    >
                      <InfoIcon />
                    </div>
                    <div
                      className="info-input__img"
                      style={{
                        top: -3,
                        left: 40,
                        opacity: isInitialPopup ? 1 : 0,
                        visibility: isInitialPopup ? "visible" : "hidden",
                      }}
                    >
                      <img
                        src={require("../../assets/images/intro3.png")}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    className="col-5"
                    style={{ paddingRight: 0, paddingLeft: 0 }}
                  >
                    <div
                      style={{
                        marginTop: 16,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          borderColor: "#7460ee",
                          borderWidth: 1,
                          borderRadius: 5,
                          borderStyle: "solid",
                          width: "85%",
                          height: 38,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            background: "#7460ee",
                            width: "21%",
                            height: "100%",
                            dispay: "flex",
                            color: "#ffffff",
                            fontSize: 8,
                            display: "flex",
                            alignItems: "center",
                            padding: "0px 4px",
                            lineHeight: "9px",
                          }}
                        >
                          Adjust % to see splits
                        </div>
                        <div
                          style={{
                            width: "78.5%",
                            height: "100%",
                            dispay: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              height: "50%",
                              display: "flex",
                              borderBottomColor: "#7460ee",
                              borderBottomWidth: 1,
                              borderBottomStyle: "solid",
                            }}
                          >
                            <div
                              style={{
                                width: "60%",
                                height: "100%",
                                background: "#7460ee",
                                color: "#ffffff",
                                fontSize: 10,
                                display: "flex",
                                alignItems: "center",
                                padding: "0px 4px",
                              }}
                            >
                              {"To Company >"}
                            </div>
                            <div
                              style={{
                                width: "40%",
                                height: "100%",
                                color: "#7460ee",
                                fontSize: 12,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              $
                              {(
                                values.minimumValue -
                                values.minimumValue *
                                  (values.give_back_campaign / 100)
                              ).toFixed(2)}
                            </div>
                          </div>
                          <div
                            style={{
                              width: "100%",
                              height: "50%",
                              display: "flex",
                            }}
                          >
                            <div
                              style={{
                                width: "60%",
                                height: "100%",
                                background: "#7460ee",
                                color: "#ffffff",
                                fontSize: 10,
                                display: "flex",
                                alignItems: "center",
                                padding: "0px 4px",
                              }}
                            >
                              {"% Give Back >"}
                            </div>
                            <div
                              style={{
                                width: "40%",
                                height: "100%",
                                color: "#7460ee",
                                fontSize: 12,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              $
                              {(
                                values.minimumValue *
                                (values.give_back_campaign / 100)
                              ).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{ top: 24, right: 8 }}
                        className="info-input__icon"
                        onMouseOver={() => setShowInitialPopup2(true)}
                        onMouseOut={() => setShowInitialPopup2(false)}
                      >
                        <InfoIcon />
                      </div>
                      <div
                        className="info-input__img"
                        style={{
                          top: 0,
                          opacity: isInitialPopup2 ? 1 : 0,
                          visibility: isInitialPopup2 ? "visible" : "hidden",
                          left: 304,
                        }}
                      >
                        <img
                          src={require("../../assets/images/intro4.png")}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className={"info-input"}>
                  <textarea
                    maxLength="250"
                    className="form-controls-light mt-3"
                    placeholder="Describe your campaign and I'll give you options to customize..."
                    id="campaignDescription"
                    style={{
                      minHeight: "150px",
                      padding: "34px 0.75rem 0.375rem 0.75rem",
                    }}
                    type="textarea"
                    name="campaignDescription"
                    value={values.campaignDescription}
                    onChange={handleChange}
                  />
                  <span
                    style={{ position: "absolute", left: "0.75rem", top: 5 }}
                  >
                    {values.campaignName}
                  </span>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p>{values.campaignDescription.length}/250</p>
                    <div style={{ width: "auto" }}>
                      <img
                        src={RefreshIcon}
                        style={{
                          width: 24,
                          height: 24,
                          filter: "brightness(0.5) contrast(10%) saturate(0%)",
                          marginRight: 8,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          generateAICampainDesc(
                            values.campaignDescription,
                            setFieldValue
                          );
                        }}
                      />
                      <button
                        onClick={() => {
                          generateAICampainDesc(
                            values.campaignDescription,
                            setFieldValue
                          );
                        }}
                        className="btn btn-primary"
                        type="button"
                        style={{
                          marginTop: 2,
                        }}
                      >
                        <img
                          src={SendIcon}
                          style={{
                            width: 16,
                            height: 16,
                            filter: "brightness(0) invert(1)",
                            marginRight: 8,
                          }}
                        />
                        Generate
                      </button>
                      <button
                        className="btn btn-primary"
                        type="button"
                        style={{
                          marginTop: 2,
                          marginLeft: 8,
                          zIndex: 999,
                          position: "relative",
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <div className="info-input__icon">
                    <InfoIcon />
                  </div>
                  <div className="info-input__img">
                    <img src="/images/infoCampaign/3.jpg" alt="" />
                  </div>
                </div>

                <div className={"info-input"}>
                  <textarea
                    className="form-controls-light mt-3"
                    placeholder="Campaigns SMS message: (be sure to include your business name so your customers know it’s from you)"
                    id="campaignSMSText"
                    maxLength="120"
                    style={{
                      minHeight: "100px",
                    }}
                    type="textarea"
                    name="campaignSMSText"
                    value={values.campaignSMSText}
                    onChange={handleChange}
                  />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p>{values.campaignSMSText.length}/120</p>
                    <div style={{ width: "auto" }}>
                      <img
                        src={RefreshIcon}
                        style={{
                          width: 24,
                          height: 24,
                          filter: "brightness(0.5) contrast(10%) saturate(0%)",
                          marginRight: 8,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          generateAICampainSMSDesc(
                            values.campaignSMSText,
                            setFieldValue
                          );
                        }}
                      />
                      <button
                        onClick={() => {
                          generateAICampainSMSDesc(
                            values.campaignSMSText,
                            setFieldValue
                          );
                        }}
                        className="btn btn-primary"
                        style={{
                          marginTop: 2,
                        }}
                        type="button"
                      >
                        <img
                          src={SendIcon}
                          style={{
                            width: 16,
                            height: 16,
                            filter: "brightness(0) invert(1)",
                            marginRight: 8,
                          }}
                        />
                        Generate
                      </button>
                      <button
                        className="btn btn-primary"
                        type="button"
                        style={{
                          marginTop: 2,
                          marginLeft: 8,
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-6 mt-3">
                <div className="col-12 p-1">
                  <label htmlFor="banner">
                    Banner (Your banner will be resized to 600px x 300px)
                  </label>
                  {editImage ? (
                    <>
                      <Cropper
                        src={banner?.campaignBanner}
                        style={{ height: 400, width: 600 }}
                        aspectRatio={6 / 3}
                        guides={false}
                        ref={cropperRef}
                      />
                      <div style={{ dispay: "flex", margin: "30px 0" }}>
                        <button
                          onClick={(e) => onClearCrop(e)}
                          className="btn btn-primary mt-3 mr-2 "
                          style={{ float: "left" }}
                        >
                          Clear
                        </button>
                        <button
                          onClick={(e) => onSaveCrop(e)}
                          className="btn btn-primary mt-3 "
                          style={{ float: "left" }}
                        >
                          Save Image
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="mb-0 col-12 p-0">
                      <img
                        src={banner ? banner.campaignBanner : null}
                        style={{
                          width: "100%",
                          minHeight: 150,
                          borderRadius: "10px",
                        }}
                      />
                      <section className="container overlayControl">
                        <Dropzone
                          onDrop={(acceptedFiles) => {
                            setFileBanner(
                              acceptedFiles.map((file) =>
                                Object.assign(file, {
                                  preview: URL.createObjectURL(file),
                                })
                              )
                            );
                            setBanner({
                              ...banner,
                              campaignBanner: acceptedFiles[0].preview,
                            });
                            setFileBanner(acceptedFiles[0].preview);
                            setEditImage(true);
                          }}
                          name="logoFile"
                          multiple={false}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div
                              {...getRootProps({
                                className: "dropzone overlayControl",
                              })}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <input
                                id="banner"
                                {...getInputProps()}
                                onChange={(e) => {
                                  handleFileReadBanner(e);
                                  console.log(e.target.files);

                                  setBanner({
                                    ...banner,
                                    campaignBanner: URL.createObjectURL(
                                      e.target.files[0]
                                    ),
                                  });
                                  setEditImage(true);
                                }}
                              />
                              <div className="perfectCenter">
                                <i className="fas fa-upload" />
                                <p className="">
                                  Drag and Drop your image or click to upload
                                </p>
                                <p className="">
                                  Using copyrighted images without permission is
                                  illegal, so ensure you use original, or
                                  royalty-free images for your campaigns.
                                </p>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                      </section>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    justifyContent: "flex-end",
                  }}
                >
                  <Link
                    to={"/campaign-manager"}
                    className="btn btn-secondary mt-3 mr-2"
                    style={{ float: "right" }}
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-primary mt-3 "
                    style={{ float: "right" }}
                  >
                    Create Campaign
                  </button>
                </div>

                <div style={{ display: "flex" }}>
                  <div
                    onClick={() => {
                      window
                        .open(
                          "https://www.youtube.com/watch?v=ynDX0wdhVDo&list=PLmis7uALvV_yqG16ihUzjTFdEKBqtEkR0&t=124",
                          "_blank"
                        )
                        .focus();
                    }}
                    style={{
                      display: "flex",
                      marginRight: 32,
                      marginTop: 53,
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 14,
                        lineHeight: 1.3,
                        whiteSpace: "break-spaces",
                        fontStyle: "italic",
                        marginRight: 8,
                        fontWeight: "bold",
                        color: "#7460ee",
                        width: 47,
                      }}
                    >
                      {"How to\nvideo"}
                    </div>
                    <img
                      src={CreateThumbnail}
                      style={{
                        height: 170,
                        width: 314,
                      }}
                    />
                  </div>
                  <div className="campaign-pdf-container mt-5">
                    <div className="campaign-pdf-footer">
                      <span className="campaign-pdf-text">
                        {"How to Create a Campaign:"}
                      </span>
                      <a data-fancybox="gallery" href={CampaignPdfThumbnail}>
                        <SearchIcon />
                      </a>
                      <a download href={CampaignPDF}>
                        <DownloadIcon />
                      </a>
                    </div>
                    <img
                      src={CampaignPdfThumbnail}
                      alt="Combined with QR Code"
                    />
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </CardBody>
    </Card>
  );
}

export default AddCampaign;
